import React from 'react';
import classes from './MediaPlayer.module.css';
import { mainHostUrl } from '../../../helpers';

type Props = {
  url: string;
  urlType: 'attachment' | 'blob';
  style?: React.CSSProperties;
  mediaType: 'audio' | 'video';
};

const MediaPlayer: React.FC<Props> = ({ url, urlType, style, mediaType }) => {
  const mediaRef = React.useRef(null);

  const [srcUrl, setSrcUrl] = React.useState<string>();
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    setSrcUrl(urlType === 'attachment' ? mainHostUrl(url) : url);
    setLoading(false);
  }, [url, urlType]);

  if (loading) {
    return null;
  }

  const MediaElement = mediaType === 'audio' ? 'audio' : 'video';

  return (
    <MediaElement
      style={{ ...style }}
      className={loading ? classes.hidden : mediaType === 'audio' ? classes.audioPlayer : ''}
      src={srcUrl}
      ref={mediaRef}
      controls
      muted={false}
    />
  );
};

export { MediaPlayer };
